import { render } from "./ViewWeek.vue?vue&type=template&id=27a4ae4f"
import script from "./ViewWeek.vue?vue&type=script&lang=js"
export * from "./ViewWeek.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__